const groupPrefix = createApiRoute(ApiModule.EXTERNAL_ORDER, ApiAuthorization.EMPLOYEE)

export const apiExternalOrders = {
	fetchExternalOrders: async (page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IExternalOrderResponse[]>(`${groupPrefix}/orders`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(ExternalOrderFromJson), meta }
	},

	retryExternalOrder: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/orders/${id}/retry`, { method: 'POST' })
	},

	importFoodsiOrders: async (file: File, confirm: boolean = false): Promise<IFoodsiImportReport> => {
		const formData = new FormData()
		formData.append('file', file)
		if (confirm) formData.append('confirm', '1')

		return (await apiCommon<IFoodsiImportReport>(
			`${groupPrefix}/imports/foodsi`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)) as unknown as IFoodsiImportReport
	},
}
